import { Card as MUICard, CardProps as MUICardProps } from "@material-tailwind/react";

export type CardProps = Omit<MUICardProps, "ref">;

export default function Card(props: CardProps): JSX.Element {
  return <MUICard {...props} />;
}
